import styles from "./ScrollTopBtn.module.css";

const ScrollTopBtn = () => {
  return (
    <a href="#top" className={styles.scrollBtn}>
      Back To Top
    </a>
  );
};

export default ScrollTopBtn;
